import { OFFER_HISTORY_STATUSES } from 'cpool-constants';
import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { OfferRequestsTableDefinitionZod, schemaAcceptedOffersEuropace, schemaOffersEuropace } from '../tables';

type Arguments = {
    id: string;
    position?: number;
};

export const schemaLoanRequestResolver_GetBankOffersByLeadId = z.object({
    offerRequests: z.array(OfferRequestsTableDefinitionZod),
    offers: z.array(
        schemaOffersEuropace.extend({
            offers: z.array(
                z.intersection(
                    schemaOffersEuropace.shape.offers.element,
                    z.object({
                        acceptedOffer: schemaAcceptedOffersEuropace.optional(),
                        status: z.nativeEnum(OFFER_HISTORY_STATUSES).nullable(),
                    }),
                ),
            ),
        }),
    ),
});

export type SchemaLoanRequestResolver_GetBankOffersByLeadId = z.infer<
    typeof schemaLoanRequestResolver_GetBankOffersByLeadId
>;

export type LoanRequestResolver_GetBankOffersByLeadId = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetBankOffersByLeadId
>;
